<template>
  <app-dropdown data-title="Operações"
                data-menu-width="380px"
                data-menu-padding="10px 20px 20px 20px"
                :data-button-gradient="true">

    <h3 class="text-bold ">Operações</h3>

    <app-search-bar @input="searchOperations($event)"></app-search-bar>

    <div class="mb-3"></div>

    <OperationsTree v-if="operations"
                    v-model="value"
                    :operations="operations"
                    :data-max-height="270"
                    @input="setOperationsFilter"></OperationsTree>

  </app-dropdown>
</template>

<script>
    import AppDropdown from '@components/Dropdown'
    import OperationsTree from '@components/OperationsTree'
    import AppSearchBar from '@components/Search'
    import filter from '@mixins/filter'

    export default {
        components: {
            AppDropdown,
            OperationsTree,
            AppSearchBar,
        },

        data() {
            return {
              key: 'operations',
              initialOperations: [],
              operations: [],
            }
        },
        
        mixins: [filter],

        methods: {
          setOperationsFilter(val) {
            this.$store.commit('AUDIT_SET_FILTER', { key: 'operations', value: val })
          },
          searchOperations(search) {
            this.operations = search ? this.initialOperations.filter((operation) => {
              return operation.label.includes(search);
            }) : this.initialOperations;
          },
        },

        async mounted() {
          this.search = '';

          const operations = await this.$api.audit.operations();

          this.initialOperations = Object.keys(operations).map((key) => {
            return {
              id: key,
              label: operations[key]
            }
          });

          this.operations = [...this.initialOperations]
        },
    }
</script>

<style scoped>
</style>
